<mat-dialog-content>
    <div class="px-16 py-8">
        <div class="flex items-center gap-5">
            <fa-icon class="text-primary-light shrink-0 mt-0.5" [icon]="['fal', 'circle-exclamation']" size="2x"></fa-icon>
            <p class="m-0">{{ text ? text : 'In order to turn this feature on you will need to log back into your ' + provider + ' account.' }}</p>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="justify-center gap-3">
    <button matButton="outlined" type="button" (click)="close()">Cancel</button>
    <button matButton="filled" type="button" (click)="proceed()">Proceed</button>
</mat-dialog-actions>
